(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["dousset-commitment-content"] && !Shopify.designMode) return;
  try {
    
document.querySelectorAll('.nav-link').forEach(function (e) {
    e.addEventListener('click', smoothScroll)
});

function smoothScroll(e) {
    e.preventDefault();
    const link = this.getAttribute('href').replace('#', '');
    const offsetTop = document.querySelector(`[id=${link}]`).offsetTop;
    scroll({
        top: offsetTop - 95,
        behavior: 'smooth',
    });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["faq-accordion"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('.faq-question').forEach(button => {
    button.addEventListener('click', () => {
      const item = button.closest('.faq-item');
      item.classList.toggle('open');
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sales-collateral-submissions"] && !Shopify.designMode) return;
  try {
    
  var FIELDS = [
    'salesAdvisor',
    'store',
    'name',
    'phone',
    'email',
    'productNames',
    'variants',
    'metal',
    'ringSizes',
    'occasion',
    'favorites',
    'notes'
  ];

  function text(value) {
    return value ? String(value) : '—';
  }

  function formatDate(value) {
    if (!value) return '—';
    var date = new Date(value);
    if (isNaN(date.getTime())) return text(value);
    return date.toLocaleString();
  }

  function cell(value) {
    var td = document.createElement('td');
    td.textContent = text(value);
    return td;
  }

  document.querySelectorAll('.sales-submissions').forEach(function (root) {
    var status = root.querySelector('[data-status]');
    var wrap = root.querySelector('[data-table-wrap]');
    var rows = root.querySelector('[data-rows]');
    var endpoint = root.getAttribute('data-endpoint') || '';

    function setStatus(message, isError) {
      status.textContent = message;
      status.classList.toggle('is-error', Boolean(isError));
    }

    if (!endpoint) {
      setStatus('Add the submissions API endpoint in the section settings.', true);
      return;
    }

    fetch(endpoint, { method: 'GET', headers: { Accept: 'application/json' } })
      .then(function (response) {
        return response.json().then(function (data) {
          return { ok: response.ok, data: data };
        });
      })
      .then(function (result) {
        var submissions = result.ok && result.data && result.data.data;
        if (!Array.isArray(submissions)) {
          setStatus((result.data && result.data.msg) || 'Unable to load submissions.', true);
          return;
        }

        if (!submissions.length) {
          setStatus('No submissions yet.');
          return;
        }

        submissions.forEach(function (submission) {
          var formData = submission.formData || {};
          var tr = document.createElement('tr');
          tr.appendChild(cell(formatDate(submission.createdAt)));
          FIELDS.forEach(function (key) {
            tr.appendChild(cell(formData[key]));
          });
          rows.appendChild(tr);
        });

        wrap.hidden = false;
        setStatus(submissions.length + (submissions.length === 1 ? ' submission' : ' submissions'));
      })
      .catch(function () {
        setStatus('Unable to load submissions. Please try again.', true);
      });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["testimonial-slider"] && !Shopify.designMode) return;
  try {
    
  $(document).ready(function(){
    $('.testimonial-slider').slick({
      arrows: true,
      dots: false,
      autoplay: true,
      autoplaySpeed: 5000,
      prevArrow: '<button type="button" class="slick-prev">←</button>',
      nextArrow: '<button type="button" class="slick-next">→</button>'
    });
  });

  } catch(e) { console.error(e); }
})();
})();
